import React from "react";

export default function Lot({ lot }) {
  const lotNumber = Number(lot);
  if (!lotNumber || isNaN(lotNumber) || lotNumber < 1) {
    return <span>-</span>;
  }
  const elements = [];
  for (let i = 1; i <= lotNumber; i++) {
    elements.push(i);
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "center" }}>
      {elements.map((num) => (
        <span
          key={num}
          style={{
            display: "inline-block",
            width: "24px",
            height: "24px",
            lineHeight: "24px",
            textAlign: "center",
            backgroundColor: "#a6a6a6",
            color: "#fff",
            borderRadius: "6px",
            fontWeight: "bold",
            fontSize: "12px",
          }}
        >
          {num}
        </span>
      ))}
    </div>
  );
}
